import React from "react";
import axios from "axios";
import "./../css/Login.css";
import Spinner from "components/Spinner";

const API = localStorage.getItem("assethost");
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      ipAddress: "",
      country: "",
      isp: "",
      errors: {},
      msg: "",
      toastColor: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.reset = this.reset.bind(this);
  }
  componentDidMount() {
    // If already logged in, redirect
    if (sessionStorage.getItem("token")) {
      window.location.href = "/dashboard";
      return;
    }
    // Get IP & geo info
    axios
      .get(
        "https://api.ipdata.co?api-key=212ad9acd89c4d7e42b8b70db2317c75e051aa7f16c81fed265ef9bd"
      )
      .then((res) => {
        this.setState({
          ipAddress: res.data.ip,
          country: res.data.country_name,
          isp: res.data.asn.name,
        });
      })
      .catch(() => { });
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }
  validate() {
    let s = this.state;
    let errors = {},
      valid = true;
    if (!s.username || !s.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      errors.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }
  handleLogin(e) {
    if (e) e.preventDefault();
    if (!this.validate()) {
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    // Handle login
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let redirectUrl = params.get("redirectUrl");
    const dataObj = {
      username: this.state.username,
      password: this.state.password,
      ipAddress: this.state.ipAddress,
      country: this.state.country,
      isp: this.state.isp,
    };
    var self = this;
    axios
      .post(API + "/login/authenticate", dataObj)
      .then((res) => {
        if (res.data.error) {
          self.setState({
            msg: res.data.error,
            toastColor: "danger",
            loading: false,
          });
        } else if (!res.data.success) {
          self.setState({
            msg: res.data.message,
            toastColor: "danger",
            loading: false,
          });
        } else {
          // Success: do not set sessionStorage here (redirect to 2fa page)
          sessionStorage.removeItem("menus");
          window.location.href = `/auth/code?username=${self.state.username
            }&redirectUrl=${redirectUrl ? redirectUrl : ""}`;
        }
      })
      .catch((err) => {
        self.setState({
          msg: err.message || "Login failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      })
      .finally(() => {
        self.setState({ loading: false });
      });
  }
  reset(e) {
    if (e) e.preventDefault();
    window.location.href = "/auth/forgot";
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div className="container mb-4">
          <div
            className={
              s.toastColor === "success"
                ? "alert alert-success"
                : "alert alert-danger"
            }
          >
            {s.msg}
          </div>
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="d-flex flex-column min-vh-100">
        {/* <Banner title="Welcome to Asset Register" align="center" /> */}
        {divMsg}
        <div className="container-fluid flex-grow-1 py-4">
          <div className="row justify-content-center align-items-start g-4">
            {/* Left Side - Welcome & Logo */}
            <div className="col-12 col-lg-5">
              <div className="text-center mb-4">
                <h4 className="fw-bold text-secondary mb-3 fs-3">
                  Welcome to Asset Register
                </h4>
                <p className="text-muted mb-4">
                  Welcome to the Asset Register where you can register and track
                  your assets, flag all assets that would have been stolen.
                </p>
                <p className="text-muted">
                  Already have an account, please login.
                  <br />
                  New to the platform? Please register.
                </p>
              </div>
              <div className="d-flex justify-content-center">
                <div className="card border-0 shadow-lg rounded-4 overflow-hidden" style={{ width: "380px", height: "240px" }}>
                  <img
                    src="/logo.png"
                    alt="Vaya Technologies logo"
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              </div>
            </div>

            {/* Right Side - Login & Registration Forms */}
            <div className="col-12 col-lg-3">
              <div className="row g-4">
                {/* Login Form */}
                <div className="col-12">
                  <div className="card border-0 shadow-lg rounded-4 p-4">
                    <h3 className="text-center fw-bold text-secondary mb-4">
                      <i className="bi bi-person-circle me-2"></i>Login
                    </h3>
                    <form autoComplete="off" onSubmit={this.handleLogin}>
                      <div className="mb-3">
                        <label htmlFor="username" className="form-label fw-semibold">
                          <i className="bi bi-person me-2"></i>Username
                        </label>
                        <input
                          type="text"
                          name="username"
                          id="username"
                          className={`form-control ${s.errors.username ? "z-0" : "z-0"}`}
                          value={s.username}
                          onChange={this.handleChange}
                          required
                          placeholder="Enter your username"
                        />
                        {s.errors.username && (
                          <div className="invalid-feedback">{s.errors.username}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label htmlFor="password" className="form-label fw-semibold">
                          <i className="bi bi-lock me-2"></i>Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          id="password"
                          className={`form-control ${s.errors.password ? "z-0" : "z-0"}`}
                          value={s.password}
                          onChange={this.handleChange}
                          required
                          placeholder="Enter your password"
                        />
                        {s.errors.password && (
                          <div className="invalid-feedback">{s.errors.password}</div>
                        )}
                      </div>
                      <div className="d-grid gap-2">
                        <button type="submit" className="btn btn-primary">
                          <i className="bi bi-box-arrow-in-right me-2"></i>Login
                        </button>
                        <div className="d-flex justify-content-center">
                          <a className="link-primary" href="/auth/forgot">
                            <i className="bi bi-question-circle me-2"></i>Forgot Password
                          </a>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Registration Options */}
                <div className="col-12">
                  <div className="card border-0 shadow-lg rounded-4 p-4">
                    <h3 className="text-center fw-bold text-secondary mb-4">
                      <i className="bi bi-person-plus me-2"></i>New User
                    </h3>
                    <div className="d-grid gap-2 justify-content-around">
                      <div className="d-flex justify-content-center">
                        <a
                          className="link-primary"
                          href="/registration/individual"
                        >
                          <i className="bi bi-person me-2"></i>Register as Individual
                        </a>
                      </div>
                      <div className="d-flex justify-content-center">
                        <a
                          className="link-primary"
                          href="/registration/corporate"
                        >
                          <i className="bi bi-building me-2"></i>Register as Corporate
                        </a>
                      </div>
                      <div className="d-flex justify-content-center">
                        <a
                          className="link-primary"
                          href="/registration/traders-channel-partner"
                        >
                          <i className="bi bi-shop me-2"></i>Register as Traders/Channel Partner
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
        <div className="mx-5 mt-2 mb-2 py-2 text-center text-muted small fst-italic">
          Powered By Ecocash & Core Create
        </div>
      </div>
    );
  }
}
